import { HorizontalContainer, Wrapper } from '@american-autonomy/ag-ui';

import StaleSyncBanner from 'pages/MaintenancePage/components/StaleSyncBanner';
import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const MaintenancePageHeader: FunctionComponent<Props> = ({
    className = '',
    onConfigureIntervals,
    testId = TEST_ID
}) => {
    const { INTERVAL_CONFIG_TITLE, PAGE_TITLE } = useTranslation();

    return (
        <HorizontalContainer className={`${styles.pageHead} ${className}`} testId={testId}>
            <Wrapper className={styles.pageTitle}>{PAGE_TITLE}</Wrapper>

            <HorizontalContainer className={styles.pageHeadActions}>
                <StaleSyncBanner />

                <Wrapper className={styles.configIntervalsBtn} onClick={onConfigureIntervals}>
                    {INTERVAL_CONFIG_TITLE}
                </Wrapper>
            </HorizontalContainer>
        </HorizontalContainer>
    );
};

export default MaintenancePageHeader;
